'use client';

export const textLang: any = {
    us: {
        line1: 'Sign up for our newsletter to receive the latest information on EcoFlow products, services, events, and news. ',
    },
};
